import { UNIFIED_INBOX_BASE_PATH } from "@circle-react/hooks/chatsV2/messaging/useMessagingPaths";
import { useLocation } from "@tanstack/react-router";

export const useIsUnifiedInboxRoute = (): boolean => {
  const pathname = useLocation({ select: location => location.pathname });

  return pathname.startsWith(UNIFIED_INBOX_BASE_PATH);
};
